import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { Typography, Icon } from '@fdha/web-ui-library';

import { getStyles } from './DeliveryCancelMessage.styles';

interface DeliveryCancelMessageProps {
  message?: string;
}

/**
 * Component to display a delivery cancellation message
 */
const DeliveryCancelMessage: FC<DeliveryCancelMessageProps> = ({
  message = 'Your delivery has been canceled.',
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box sx={styles.canceledContainer}>
      <Typography
        variant="body2"
        sx={styles.canceledText}
        i18nKey="meals:deliveryStatus.cancelled"
      >
        {message}
      </Typography>
      <Icon
        name="close-circle-outline"
        size="large"
        fill={theme.palette.text.secondary}
        backgroundColor={theme.palette.grey[200]}
      />
    </Box>
  );
};

export default DeliveryCancelMessage;
